import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useCredits } from '@/hooks/useCredits';

const PLANS = [
  {
    id: 'starter',
    label: 'Starter',
    audience: 'Individual',
    price: 'R$ 49',
    period: '/mês',
    renders: '20 renders / mês',
    format: 'Formato 16:9 · Alta resolução · PIX',
    asaas: 'https://www.asaas.com/c/sc9sruh61ldop0hc',
  },
  {
    id: 'pro',
    label: 'Pro',
    audience: 'Escritório pequeno',
    price: 'R$ 149',
    period: '/mês',
    renders: '80 renders / mês',
    format: 'Formato 21:9 cinematic · Variantes × 3 · Prioridade na fila',
    badge: 'mais popular',
    asaas: 'https://www.asaas.com/c/0gurrnt6ea2hnas6',
  },
  {
    id: 'agencia',
    label: 'Agência',
    audience: 'Escritório',
    price: 'R$ 499',
    period: '/mês',
    renders: '350 renders / mês',
    format: 'Multi-conta · Branding · API · Gerente dedicado',
    asaas: 'https://www.asaas.com/c/xs4soxlxn00dqouw',
  },
] as const;

export const CreditsPage = () => {
  const credits = useCredits();

  return (
    <div className="mx-auto max-w-4xl space-y-8 p-6 lg:p-10">
      <header className="space-y-1">
        <h1 className="text-3xl font-display">Créditos</h1>
        <p className="text-muted-foreground">
          Você tem <span className="font-semibold text-foreground">{credits.data ?? 0}</span> créditos disponíveis.
          Acabaram? Assina um plano abaixo e renova todo mês.
        </p>
      </header>

      <div className="grid gap-4 md:grid-cols-3">
        {PLANS.map((p) => (
          <Card key={p.id} className="flex flex-col">
            <CardHeader>
              <CardTitle className="flex items-center justify-between">
                {p.label}
                {'badge' in p && p.badge ? (
                  <span className="rounded bg-primary px-2 py-0.5 text-[10px] font-medium uppercase text-primary-foreground">
                    {p.badge}
                  </span>
                ) : null}
              </CardTitle>
              <CardDescription>{p.audience}</CardDescription>
            </CardHeader>
            <CardContent className="mt-auto space-y-3">
              <p>
                <span className="text-2xl font-semibold">{p.price}</span>
                <span className="text-sm text-muted-foreground">{p.period}</span>
              </p>
              <p className="text-sm font-medium text-foreground">{p.renders}</p>
              <p className="text-xs leading-relaxed text-muted-foreground">{p.format}</p>
              <Button className="w-full" asChild>
                <a href={p.asaas} target="_blank" rel="noreferrer">
                  Assinar {p.label}
                </a>
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>

      <p className="text-xs text-muted-foreground">
        PIX, cartão ou boleto via Asaas · NFS-e automática · sem fidelidade, cancele em 1 clique.
        Precisa de volume customizado ou pacote avulso? Fala com a gente em <a href="mailto:contato@portico.studio" className="underline">contato@portico.studio</a>.
      </p>
    </div>
  );
};
